// extracted by mini-css-extract-plugin
export default {"main__title_wrapper":"ForkliftsCatalog_main__title_wrapper__2ooTg","main__catalog_title":"ForkliftsCatalog_main__catalog_title__pFHWx"};